import { style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

export const panel = style(
  {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  'sidebar-panel',
);

export const body = style(
  {
    flex: 1,
    minHeight: 0,
    overflow: 'auto',
    padding: themeVars.space['200'],
  },
  'sidebar-panel-body',
);

export const footer = style(
  {
    borderTop: `${themeVars.border['width-0125']} solid ${themeVars.color['scope-neutral-subtle-border']}`,
    padding: themeVars.space['200'],
  },
  'sidebar-panel-footer',
);
